// MUI BottomNavigation default root height; not overridden in our themes.
export const MOBILE_BOTTOM_NAV_HEIGHT_PX = 56;

export const MOBILE_TOP_BAR_HEIGHT = 48;

export const MOBILE_FAB_NAV_GAP_PX = 24;

export const MOBILE_SAFE_AREA_BOTTOM_VAR = "--mobile-safe-area-bottom";

export const mobileSafeAreaBottom = `var(${MOBILE_SAFE_AREA_BOTTOM_VAR})`;

export const mobileFabBottomOffset = `calc(${MOBILE_BOTTOM_NAV_HEIGHT_PX + MOBILE_FAB_NAV_GAP_PX}px + ${mobileSafeAreaBottom})`;

export const desktopFabBottomOffset = "96px";

export const MOBILE_TOP_BAR_ZINDEX = 1100;

export const MOBILE_SUB_HEADER_ZINDEX = 1099;

export const MOBILE_STATUS_SCRIM_ZINDEX = MOBILE_TOP_BAR_ZINDEX;

export const mobileSafeAreaTop = "env(safe-area-inset-top)";

export const mobileTopBarTop = mobileSafeAreaTop;

export const MOBILE_TOP_BAR_OFFSET_VAR = "--mobile-top-bar-offset";

export const mobileTopBarOffset = `calc(${mobileSafeAreaTop} + ${MOBILE_TOP_BAR_HEIGHT}px)`;

export const mobileSubHeaderTop = `var(${MOBILE_TOP_BAR_OFFSET_VAR}, ${mobileSafeAreaTop})`;
